// styles.js

export const getStyles = (isMobile, isSearchTriggered, isCollapsed) => ({
    topBar: {
      position: isSearchTriggered ? 'absolute' : 'fixed',
      top: isSearchTriggered ? '20px' : '50%',
      left: isSearchTriggered ? (isCollapsed ? '240px' : '410px') : '50%',
      transform: isSearchTriggered ? 'none' : 'translate(-50%, -50%)',
      zIndex: 1000,
      transition: 'all 0.3s ease',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      width: isSearchTriggered ? '300px' : '400px',
    },
    searchContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'relative',
      width: isMobile ? '85%' : '500px',
      backgroundColor: isSearchTriggered ? 'rgba(30, 30, 30, 0.7)' : '#141414',
      backdropFilter: 'blur(30px)',
      padding: isMobile ? '8px 12px' : '8px 22px',
      borderRadius: '10px',
      border: isSearchTriggered ? '#000' : '2px solid #ccc',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
      zIndex: 1000,
      marginBottom: '12px',
    },
    searchInputContainer: {
      display: 'flex',
      flex: 1,
      alignItems: 'center',
    },
    input: {
      flex: 1,
      border: 'none',
      backgroundColor: 'transparent',
      padding: isMobile ? '8px' : '8px',
      borderRadius: '15px',
      marginRight: '8px',
      fontFamily: "'Poppins', sans-serif",
      fontSize: isMobile ? '14px' : '16px',
      color: isSearchTriggered ? '#ccc' : '#fff',
      outline: 'none',
    },
    iconButton: {
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      padding: '0',
      marginLeft: '8px',
      outline: 'none',
      backgroundColor: 'transparent',
    },
    icon: {
      width: isMobile ? '20px' : '24px',
      height: isMobile ? '20px' : '24px',
      display: isSearchTriggered ? 'none' : 'block',
    },
    button: {
      padding: '8px 16px',
      borderRadius: '8px',
      backgroundColor: '#0066cc',
      color: '#fff',
      border: 'none',
      cursor: 'pointer',
      fontFamily: "'Poppins', sans-serif",
      fontSize: '14px',
      fontWeight: 600,
    },
    tagline: {
      fontSize: isMobile ? '28px' : '36px',
      fontStyle: 'italic',
      color: '#fff',
      fontFamily: "'EB Garamond', serif",
      fontWeight: 200,
      marginBottom: '32px',
      textAlign: 'center',
      width: '140%',
    },
  });
  